// Deliberately a leaf module with no other imports: config.guest.ts pulls only constants from each
// component to keep the guest metadata registry lightweight.
// Versioned filename because the CDN serves these immutably (max-age=604800). Earlier versions are
// superseded and must not be used: v1_0_1 declared `format: "uri"`, which event_service's bare
// `new Ajv()` cannot compile, so every write against it failed; v1_0_2 replaced that with a
// maxLength the shared form cannot enforce (a capped field renders a character counter, which this
// design does not have), so an over-long paste would have failed the whole write with a generic
// error. v1_0_3 fixed both and is the first version that reached production, which is why it is the
// first one with a migration entry rather than a silent replacement. This version constrains no
// string length. See PageSchedule.schema.spec.ts.
export const PAGE_SCHEDULE_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/pageScheduleSchemaV1_0_4.json' as const;

// v1_0_4 only adds the optional `showWhereToStay` item field, so a v1_0_3 blob is already valid
// v1_0_4 content and the migration re-stamps the URL without touching values. The constant has to
// stay because the item object is `additionalProperties: false`: a blob still naming v1_0_3 is
// validated against v1_0_3 by event_service, where the new key would be rejected on write.
export const PAGE_SCHEDULE_V1_0_3_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/pageScheduleSchemaV1_0_3.json' as const;

export const PAGE_SCHEDULE_COMPONENT_TYPE = 'PageSchedule' as const;
